var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-9 col-lg-8"},[(_vm.resources.length > 0)?_vm._l((_vm.resources),function(resource){return _c('ResourcePreviewCard',_vm._b({key:resource.uuid,attrs:{"heading-level":3}},'ResourcePreviewCard',resource,false))}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }